// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { LogLevel } from '@wellro/utils';

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyBdr3MDwCY1Ltz1er0SeJBCSCjPRPUvIOk',
    authDomain: 'wellro-wellness-staging.firebaseapp.com',
    projectId: 'wellro-wellness-staging',
    storageBucket: 'wellro-wellness-staging.appspot.com',
    messagingSenderId: '125729254720',
    appId: '1:125729254720:web:343a0d5a1fec03d170dea5',
    measurementId: 'G-TYT05QC2Q2',
  },
  sentry: {
    dsn:
      'https://70510fe5dcd2445bb5ea176c5d805032@o4504682974740480.ingest.sentry.io/4504693742239744',
    env: 'staging',
    replaysSessionSampleRate: 0.1,
  },
  tenantId: 'doctor-5im05',
  logLevel: LogLevel.DEBUG,
  hostUrl: 'https://staging-doctor.wellro.life',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
